import addKeyLocalStorage from './localStorage'
import appUserService from '../services/appUserService'

export const METADATA_CACHE_KEY = 'METADATA_CACHE'
export const METADATA_CACHE_TTL = 24 * 60 * 60 * 1000 // 24h
let metadataRequestPromise = null

function getMetadataCacheStorageKey() {
  return addKeyLocalStorage(METADATA_CACHE_KEY)
}

function readMetadataCache() {
  try {
    const raw = localStorage.getItem(getMetadataCacheStorageKey())
    if (!raw) return null

    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed.timestamp !== 'number' || parsed.data === undefined) {
      return null
    }

    return parsed
  } catch {
    return null
  }
}

export function loadMetadataCache({ allowExpired = false } = {}) {
  const parsed = readMetadataCache()
  if (!parsed) return null

  if (!allowExpired && Date.now() - parsed.timestamp > METADATA_CACHE_TTL) {
    return null
  }

  return parsed.data
}

export function saveMetadataCache(data) {
  try {
    localStorage.setItem(
      getMetadataCacheStorageKey(),
      JSON.stringify({
        timestamp: Date.now(),
        data
      })
    )
  } catch {}
}

export function clearMetadataCache() {
  try {
    localStorage.removeItem(getMetadataCacheStorageKey())
  } catch {}
}

export async function fetchMetadataWithCache(options = {}) {
  const { force = false } = options

  if (!force) {
    const cached = loadMetadataCache()
    if (cached) return cached
  }

  if (metadataRequestPromise) {
    return metadataRequestPromise
  }

  metadataRequestPromise = appUserService.PartnerGetMetaData({})
    .then((result) => {
      if (result?.statusCode === 200 && result?.data) {
        saveMetadataCache(result)
      }

      return result
    })
    .finally(() => {
      metadataRequestPromise = null
    })

  return metadataRequestPromise
}
